import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import PublicSite from "./pages/PublicSite";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading, checked, checkAuth } = useAuth();
  useEffect(() => { if (!checked && !loading) checkAuth(); }, [checked, loading, checkAuth]);
  if (loading || !checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy text-white">
        <Loader2 className="w-8 h-8 animate-spin text-warm" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicSite />} />
      <Route path="/butikk" element={<ShopPage />} />
      <Route path="/butikk/:slug" element={<ProductPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
